module.exports = __webpack_public_path__ + "static/media/painManagementImage1@3x.5fc5f3dc.png";